import { Checkbox, FormControlLabel, Grid } from '@mui/material';
import PropTypes from 'prop-types';

export default function BookingFeeTerms({ bookingFeeTerms, onChangeBookingFeeCheck }) {
  return (
    <div>
      <Grid container justifyContent="center">
        <FormControlLabel
          control={<Checkbox checked={bookingFeeTerms} onChange={onChangeBookingFeeCheck} />}
          label="I acknowledge that if I am selected to vend at this event, I will be charged by the vendor fee set by the venue."
        />
      </Grid>
    </div>
  );
}

BookingFeeTerms.propTypes = {
  bookingFeeTerms: PropTypes.bool,
  onChangeBookingFeeCheck: PropTypes.func,
};

BookingFeeTerms.defaultProps = {
  bookingFeeTerms: false,
  onChangeBookingFeeCheck: () => {},
};
